module.exports = __webpack_public_path__ + "static/media/referral-count.80b43224.svg";